import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import "./ResultsTotal.scss";

const ResultsTotal = ({ isVisible, total, searchResultsLabel }) => (
    <div className="team-modal-results-total">
        {isVisible && (
            <div className="team-modal-results-total__content -padding-left--15">
                <p className="-padding--5">
                    <Icon
                        className="-margin-right--10"
                        glyph="users-solid"
                        type="FontAwesome"
                    />
                    <small>
                        <strong>{total}</strong> {searchResultsLabel}
                    </small>
                </p>
            </div>
        )}
    </div>
);

ResultsTotal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    searchResultsLabel: PropTypes.string.isRequired,
};

export default ResultsTotal;
